import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams } from 'ionic-angular';
import { IngredientsServices } from "../../services";
import { IngredientCompCreateImagePage } from "../ingredient-comp-create-image/ingredient-comp-create-image";
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { StockListPage } from '../../../stock/stock-list/stock-list';

/**
 * Generated class for the IngredientCompCreatePreparationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ingredient-comp-create-preparation',
    templateUrl: 'ingredient-comp-create-preparation.html',
})
export class IngredientCompCreatePreparationPage {
    update_state: boolean = false;
    ingredient_uid: any;
    recipe: string = '';
    tools: string = '';
    time: string = '';
    ingredient_name: string;
    //
    _recipe: string = '';
    _tools: string = '';

    show_alert: boolean = true;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public ingredientsServices: IngredientsServices,
        public globals: Globals,
        private alertCtrl: AlertController,
        public translate: TranslateService,) {

        this.update_state = this.navParams.get('update_state');
        this.ingredient_uid = this.navParams.get('ingredient_uid');
        this.ingredient_name = this.navParams.get('ingredient_name');

        if (this.update_state) {
            this.recipe = this.navParams.get('recipe');
            this.tools = this.navParams.get('tools');
            this.time = this.navParams.get('time');
            this._recipe = this.navParams.get('recipe');
            this._tools = this.navParams.get('tools');


        }
    }

    ionViewCanLeave(): Promise<void> {
        return new Promise((resolve, reject) => {
            //Si el show_alert es true i no estem fen un update al plat
            if (this.show_alert && !this.update_state) {
                let alert = this.alertCtrl.create({
                    title: this.translate.instant('general-atencion'),
                    message: this.translate.instant('general-salir-proceso-creacion'),
                    subTitle: this.translate.instant('general-se-eliminara-elemento'),
                    buttons: [
                        {
                            text: this.translate.instant('general-no'),
                            role: 'cancel',
                            handler: () => {
                                this.globals.side_menu_active = 'stock';
                                reject();
                            },
                        },
                        {
                            text: this.translate.instant('general-si'),
                            handler: () => {
                                this.ingredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).delete();
                                resolve();
                                this.navCtrl.setRoot(StockListPage);
                            },
                        },
                    ],
                });
                alert.present();
            } else {
                resolve();
            }
        });
    }

    public getInitRecipe(editor: any) {
        if (editor.html) {
            this.recipe = editor.html;
        }
    }
    public getInitTools(editor: any) {
        if (editor.html) {
            this.tools = editor.html;
        }
    }


    update() {
        this.show_alert = false;
        if (!this.recipe) {
            this.recipe = '';
        }
        if (!this.tools) {
            this.tools = '';
        }
        if (!this.time) {
            this.time = '';
        }
        this.ingredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
            'recipe': this.recipe,
            'tools': this.tools,
            'time': this.time,
            'updated_at': new Date(),
            'updated_user': this.globals.user_name
        }).then(() => {
            if (this.update_state) {
                this.globals.GAtrackView('Ingredients', 'Ingredients - Preparation - Update', this.globals.restaurant.email, 'Create/Update', 'Update preparation', 'Ingredients', this.ingredient_name);
                this.navCtrl.pop();
            } else {
                this.globals.GAtrackView('Ingredients', 'Ingredients - Preparation - Create', this.globals.restaurant.email, 'Create/Update', 'Create preparation', 'Ingredients', this.ingredient_name);
                this.navCtrl.push(IngredientCompCreateImagePage, {
                    update: this.update_state,
                    ingredient_uid: this.ingredient_uid,
                    ingredient_name: this.ingredient_name
                })
            }
        });
    }



}


// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-comp-create/ingredient-comp-create-preparation/ingredient-comp-create-preparation.ts